import { useCallback } from "react";
import { Vod2d } from "./vod-2d";
import { VodVr } from "./vod-vr";
import { useRouter } from "next/router";
import type { VideoLegacySeasonType } from "~/components/blocks/product/type-guard";
import { PATHS } from "~/const/paths";
import { usePurchaseModalActions } from "~/hooks/use-purchase-modal-actions";
import { useQueryString } from "~/hooks/use-query-string";
import { G_VideoContentType } from "~/lib/graphql";
import { goToWelcomePage } from "~/util/go-to-welcome-page";

export type PartProps = { videoLegacySeasonData: VideoLegacySeasonType };

export const Part = (props: PartProps) => {
  const { videoLegacySeasonData } = props;

  const {
    content: {
      contentType,
      ppvProducts,
      svodProduct,
      viewingRights: { isStreamable, windowsURLSchemes, iosURLSchemes, androidURLSchemes },
      playInfo: { parts },
    },
  } = videoLegacySeasonData;

  const { push } = useRouter();
  const { season } = useQueryString();
  const { pushWithQueriesPurchaseModal } = usePurchaseModalActions();

  const handleVod2DPartBtnPressed = useCallback(
    async (contentId: string, partNumber: number) => {
      // 2D作品の場合
      if (contentType === G_VideoContentType.Vod_2D) {
        if (!isStreamable) {
          if (ppvProducts.length > 0) {
            pushWithQueriesPurchaseModal(contentId);
            return;
          }

          if (svodProduct !== undefined && svodProduct !== null) {
            goToWelcomePage();
            return;
          }

          return;
        }

        void push({
          pathname: PATHS.VOD_PLAYER,
          query: {
            season,
            content: contentId,
            part: `${partNumber}`,
          },
        });
      }

      return;
    },
    [season]
  );

  return (
    <>
      {contentType === G_VideoContentType.Vod_2D && (
        <Vod2d parts={parts} handleVod2DPartBtnPressed={handleVod2DPartBtnPressed} />
      )}

      {contentType === G_VideoContentType.VodVr && (
        <VodVr
          windowsURLSchemes={windowsURLSchemes}
          iosURLSchemes={iosURLSchemes}
          androidURLSchemes={androidURLSchemes}
        />
      )}
    </>
  );
};
